import { call, put, select, takeLatest } from 'redux-saga/effects';

import addOnService from 'services/addOnsService';

import { getGroupId } from 'store/session/selectors';

import { createAddOn, entities, types } from './actions';

export default function* root() {
  yield takeLatest(types.CREATE_ADD_ON_REQUEST, watchCreateAddOn);
}

function* watchCreateAddOn(action) {
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(addOnService.create, groupId, action.payload);
    yield put(createAddOn.success({ addOn: response }));
  } catch (error) {
    yield put(createAddOn.error(error));
  }
}

export function* initAddOnsListPage() {
  try {
    const groupId = yield select(getGroupId);
    const response = yield call(addOnService.list, groupId);
    yield put(entities.recieveAddOnDefs({ addOnDefs: response }));
  } catch (error) {
    console.error('ERROR WHEN FETCHING ADD-ONS', error);
  }
}
